import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CurrencyPricePipe } from '@delon/util';

interface PayBillKnockoffItem {
  type: string;
  date: string;
  docNo: string;
  description: string;
  outstanding: number;
  amount: number;
  payment: number;
}

interface PayBillAccountItem {
  accountCode: string;
  accountName: string;
  description: string;
  amount: number;
}

@Component({
  selector: 'app-transaction-preview-pay-bill',
  standalone: true,
  imports: [CurrencyPricePipe, DecimalPipe],
  templateUrl: './transaction-preview-pay-bill.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransactionPreviewPayBillComponent {
  @Input() currencyCode: string | null = null;
  @Input() knockoffItems: PayBillKnockoffItem[] | null = null;
  @Input() unmatchedAmount: number | null = null;
  @Input() accountItems: PayBillAccountItem[] | null = null;
  @Input() accountTotal: number | null = null;
  @Input() taxableAmount: number | null = null;
  @Input() taxAmount: number | null = null;
  @Input() netTotal: number | null = null;
}
